// extracted by mini-css-extract-plugin
export default {"container":"style_container__SvBZp","item_noLink":"style_item_noLink__Ujlvl","item":"style_item__8EMfb"};